export const AUTH = {
  LOGIN: "/admin-login",
  VERIFY_2FA: "/admin-login/verify-2fa",
  ENABLE_2FA: "/2fa/enable",
  CONFIRM_2FA: "/2fa/confirm",
  INVITE: "/invite/:token",
  SET_PASSWORD: "/set-password/:token",
  RESET_PASSWORD: "/reset-password",
} as const;

export const ADMIN = {
  LIST: "/adminlist",
  PERMISSIONS: "/permissions",
  ROLES: "/roles",
  INVITE: "admin-user/invite",
  EDIT: "/edit/:id",
  DELETE: "/delete/:id",
  USER_PERMISSIONS: "/admin-with-permissions/:id",
  UPDATE_USER_PERMISSIONS: "/update-permissions/:id"
} as const;

export const USER = {
  LIST: "/users",
  PENDING_VA_REQUESTS: "/pending-va-request-users/:curr",
  DETAIL: "/users/:id",
  RESTRICT: "/restrict/:id",
  MANUAL_REVIEW: "/users/:id/manual-review",
  UPDATE_BVN_STATUS: "/user/update-bvn-status",
  UPDATE_DOCUMENT_VERIFICATION: "/update-user-document-verification-status",
  UPDATE_ADDRESS_VERIFICATION: "/users/:userId/update-address-verification",
  UPDATE_PASSPORT: "/users/:userId/update-passport",
  UPDATE_ACCOUNT_REQUEST: "/users/:userId/update-account-request/:requestId",
  EXPORT_ALL: "/users/export/all",
} as const;

export const BUSINESS = {
  LIST: "/businesses",
  DETAIL: "/businesses/:id",
  RESTRICT: "/businesses/restrict/:id",
  MANUAL_REVIEW: "/businesses/:id/manual-review",
  SHAREHOLDER_MANUAL_REVIEW: "/businesses/shareholders/:id/manual-review",
  RESTRICT_TEAM_MEMBER: "/businesses/:businessId/user/:userId/restrict",
  CREATE_EXCHANGE_RATE: "/business-exchange-rates/create",
  EXPORT_ALL: "/businesses/export/all",
} as const;

export const BUSINESS_CUSTOMER = {
  LIST: "/businesses/customers",
  DETAIL: "/businesses/customers/:id",
  RESTRICT: "/businesses/customers/:id/restrict",
  UNRESTRICT: "/businesses/customers/:id/unrestrict",
} as const;

export const EXCHANGE_RATE = {
  LIST: "/exchange-rates",
  DETAIL: "/exchange-rates/:id",
  WITH_FEES: "/exchange-rates/:id/with-fees",
  SETTINGS: "/settings",
  PAYOUT_TYPE: "/exchange-rates/:id/payout-type",
  TOGGLE_PAIR_STATUS: "/exchange-rates/:id/toggele-pair-status",
  EDIT_FEE: "/edit-exchange-fee",
  CHANNEL_FEES: "/channel-fees",
  CHANNEL_FEE_DETAIL: "/channel-fees/:id",
  UPDATE_CHANNEL_FEE: "/channel-fees/update/:id",
} as const;

export const TRANSACTION = {
  LIST: "/transactions/:transactionType",
  VERIFY_USER: "/transactions/verify-business",
  UPDATE_STATUS: "/transactions/:id/:statusType",
  MANUAL_DEPOSIT: "/transactions/manual-deposit",
  MANUAL_DEBIT: "/transactions/manual-debit",
  EXPORT: "/:path/export",
  EXPORT_WITH_TRAILING_SLASH: "/:path/export/",
} as const;

export const CHARITY = {
  LIST: "/charities",
  DETAIL: "/charity/:id",
  DONORS: "/charity/:id/donors",
  CREATE: "/charity/",
} as const;

export const CURRENCY = {
  LIST: "/currencies",
  DETAIL: "/currencies/:id",
  STATUS: "/currencies/:id/status",
  UPDATE_LIMIT: "currencies/:currencyId",
} as const;

export const BENEFICIARY = {
  LIST: "/recipient/all",
  DETAIL: "/recipient/:id",
  UPDATE_SCREENING_STATUS: "/recipient/update-screening-status/:id",
} as const;

export const PROFILE = {
  DETAIL: "/profile",
  ACCOUNT_DETAILS: "/admin/account-details",
  CHANGE_PASSWORD: "/change-password",
} as const;

export const SANCTION = {
  FLAGGED_USERS: "/users/aml/flagged",
  AML_VERIFICATION: "/user/:id/aml-verification",
  EXPORT_FLAGGED: "/flagged-users/export",
} as const;

export const AUDIT = {
  TRAIL: "/audit-trails",
} as const;

export const DASHBOARD = {
  SUMMARY: "/dashboard",
} as const;
